import cn from 'classnames';
import { type FC } from 'react';

import dibsCss from 'dibs-css';
import styles from './PdpMobileMarketplaceLoadingCarousel.scss';

export const PdpMobileMarketplaceLoadingCarousel: FC = () => {
    return (
        <div className={dibsCss.pSmall}>
            <div
                className={cn(
                    styles.title,
                    styles.animate,
                    dibsCss.w200px,
                    dibsCss.mbSmall,
                    dibsCss.roundedSmall
                )}
            />
            <div
                className={cn(
                    dibsCss.flex,
                    dibsCss.wFull,
                    dibsCss.gapMedium,
                    dibsCss.contentCenter,
                    dibsCss.overflowHidden
                )}
            >
                {[1, 1].map((_, index) => (
                    <div
                        key={index}
                        className={cn(
                            styles.item,
                            styles.animate,
                            dibsCss.h250px,
                            dibsCss.shrink0,
                            dibsCss.pXxsmall,
                            dibsCss.roundedSmall
                        )}
                    />
                ))}
            </div>
        </div>
    );
};
